<template>
  <div>
    <br>
    <div style="display:flex; justify-content:flex-end;">
      <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
    </div>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :parentData="parentData"
              :actions="false"
              @params="paramsTable"
    >
      <template slot="expandedRowRender" slot-scope="{text}">
        <template v-for="ve in master.valoresExpandidos">
          {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
        </template>
      </template>
    </g-master>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        fileNameExcel: 'contabilidad',
        paramsT: {},
        endpointExcel: 'ctb_hist_contabilidad/downloadExcel',
        master: {
          valoresExpandidos: [
            {label: 'Fecha inicial', column: 'fecha_inicio'},
            {label: 'Fecha final', column: 'fecha_fin'},
            {label: 'N2', column: 'n2'},
            {label: 'N3', column: 'n3'},
            {label: 'N4', column: 'n4'},
            {label: 'N5', column: 'n5'},
            {label: 'Centro de costo', column: 'cencos'},
            {label: 'Cc1', column: 'cc1'},
            {label: 'Cc2', column: 'cc2'},
            {label: 'Cc3', column: 'cc3'},
            {label: 'Cc4', column: 'cc4'},
            {label: 'Cc5', column: 'cc5'},
            {label: 'Cc6', column: 'cc6'},
            {label: 'Oficina', column: 'office'},
            {label: 'Doc. 1', column: 'docu1'},
            {label: 'Otros1', column: 'otros1'},
            {label: 'Otros2', column: 'otros2'},
            {label: 'Otros3', column: 'otros3'},
            {label: 'Otros4', column: 'otros4'},
            {label: 'Otros5', column: 'otros5'},
            {label: 'Cc consec', column: 'cc_consec'},
            {label: 'Consec Comp', column: 'consec_comp'},
            {label: 'Fecha del sistema', column: 'date_system'},
            {label: 'Nombre de usuario', column: 'user_name'}
          ],
          endpoint: 'ctb_hist',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            actions: false,
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID Empleado', dataIndex: 'id_emp', sorter: true, width: 140},
              {title: 'Nombre Empleado', dataIndex: 'nombre_empleado', sorter: true},
              {title: 'Año', dataIndex: 'ano', sorter: true},
              {title: 'Mes', dataIndex: 'mes', sorter: true},
              {title: 'Periodo', dataIndex: 'periodo', sorter: true},
              {title: 'ID Concepto', dataIndex: 'id_coc', sorter: true, width: 130},
              {title: 'Nombre Concepto', dataIndex: 'coc_name', sorter: true, width: 140},
              {title: 'Nat. Concepto', dataIndex: 'docu2', sorter: true, width: 130},
              {title: 'Valor', dataIndex: 'ammount', sorter: true},
              {title: 'Valor Total', dataIndex: 'ammount_l', sorter: true, width: 120},
              {title: 'Cuenta Contable', dataIndex: 'n1', sorter: true, width: 140},
              {title: 'Nat. Cuenta', dataIndex: 'n6', sorter: true, width: 110},
              {title: 'Tipo Comprobante', dataIndex: 'cod_tipcomp', sorter: true, width: 150},
              {title: 'Tipo Pago', dataIndex: 'form_liq', sorter: true}

            ]
          }
        }
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      parentData () {
        return {filter_parent_ctb_hist: true}
      },
      paramsExcel () {
        return {...this.paramsT, ...this.parentData}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Consultas/CtbHist.vue